//@Actions
const actionTypes = require('constants/actionTypes');

const {
    BROKER_PRODUCT_ADVANCED_SEARCH_TERM,
    TYPE_PLANS,
    TYPE_ETFS,
    TYPE_FUNDS,
    TYPE_STOCKS,
    TYPE_WARRANTS,
    BROKER_SEARCH_WIDGET_UTAG_VIEW_ALL_STOCKS,
    BROKER_SEARCH_WIDGET_UTAG_VIEW_ALL_FUNDS,
    BROKER_SEARCH_WIDGET_UTAG_VIEW_ALL_WARRANTS,
    BROKER_SEARCH_WIDGET_UTAG_VIEW_ALL_ETFS,
    BROKER_SEARCH_WIDGET_UTAG_VIEW_ALL_PLANS,
    BROKER_SEARCH_WIDGET_UTAG_VIEW_ALL_RESULTS
} = require('constants/index');

const trackClickProductEvent = () => (dispatch, getState) => {
    const term = getState().brokerProductFiltersSearch.getIn(['search', BROKER_PRODUCT_ADVANCED_SEARCH_TERM]);
    dispatch({
        type: actionTypes.BROKER_SIMPLE_SEARCH_PRODUCT_TRACKING,
        payload: {
            term
        }
    });
};

const getProductTypeLabel = (productType) => {
    switch (productType) {
        case TYPE_PLANS:
            return BROKER_SEARCH_WIDGET_UTAG_VIEW_ALL_PLANS;
        case TYPE_ETFS:
            return BROKER_SEARCH_WIDGET_UTAG_VIEW_ALL_ETFS;
        case TYPE_FUNDS:
            return BROKER_SEARCH_WIDGET_UTAG_VIEW_ALL_FUNDS;
        case TYPE_WARRANTS:
            return BROKER_SEARCH_WIDGET_UTAG_VIEW_ALL_WARRANTS;
        case TYPE_STOCKS:
            return BROKER_SEARCH_WIDGET_UTAG_VIEW_ALL_STOCKS;
    }
    return BROKER_SEARCH_WIDGET_UTAG_VIEW_ALL_RESULTS;
}

const simpleSearchProductLinkTracking = (productType) => (dispatch, getState) => {
    const productTypeLabel = getProductTypeLabel(productType);
    const term = getState().brokerProductFiltersSearch.getIn(['search', BROKER_PRODUCT_ADVANCED_SEARCH_TERM]);
    dispatch({
        type: actionTypes.BROKER_ADVANCED_SEARCH_KEEP_FILTERS_PRODUCT_TRACKING,
        payload: {
            term,
            productTypeLabel
        }
    });
}

const simpleSearchViewAllLinkTracking = () => (dispatch, getState) => {
    const term = getState().brokerProductFiltersSearch.getIn(['search', BROKER_PRODUCT_ADVANCED_SEARCH_TERM]);
    const searchEmpty = getState().brokerSearchWidget.get('searchEmpty');
    dispatch({
        type: actionTypes.BROKER_ADVANCED_SEARCH_KEEP_FILTERS_TRACKING,
        payload: {
            term,
            searchEmpty
        }
    });
}

module.exports = {
    trackClickProductEvent,
    simpleSearchProductLinkTracking,
    simpleSearchViewAllLinkTracking
};
